export enum MediaType {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  PHOTO = 'PHOTO',
}

export enum PreviewMediaType {
  IMAGE = 'image',
  VIDEO = 'video',
}

export interface BaseMedia {
  src: string;
  height?: number;
  width?: number;
}

export interface IVideo extends BaseMedia {
  poster?: string;
  duration?: number;
}

export interface IImage extends BaseMedia {
  alt?: string;
}

export type FlowMedia = {
  id: string;
  url: string;
  width?: number;
  height?: number;
  type: MediaType;
  driveUid?: string;
  poster?: string;
};
